var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"responsibility-assignments-tab"},[_c(_setup.ResponsibilityAssignmentsTable,{attrs:{"current-response":_vm.currentResponse,"data-stream":_setup.assignmentsListData},on:{"weightChanged":_setup.handleWeightChanged,"removeBadge":_setup.handleRemoveBadge}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }